import React, { useState, useReducer } from 'react';
import { useIntl } from 'umi';
import { Segment } from 'tea-component';
import InsightsComp from './index';
import { IAction } from '../../typings';
import './index.scss';

const reducer = (state: any, { type, payload }: IAction) => ({
  ...state,
  [type]: payload,
});

export default function Comp(props: any) {
  const { genreSource, entityType, pcGameSegmentClassName } = props;
  const [segment, setSegment] = useState(entityType === 'total' ? 'mobile' : entityType);
  const [destroyed, setDestroyed] = useState(false);

  const isMarketTypeSegmentHide = genreSource === 'annie';
  const { formatMessage } = useIntl();
  const handleDestroyed = () => {
    setDestroyed(true);
    setTimeout(() => {
      setDestroyed(false);
    }, 0);
  };

  const [date, dateDispatch] = useReducer(reducer, {
    selected: '',
    newBlockbuster: '',
    newBlockbusterOri: '',
    CRTen: '',
    CRTenOri: '',
    bigRiser: '',
    bigRiserOri: '',
    newRelease: '',
    newReleaseOri: '',
    upcoming: '',
    upComingOri: '',
    dataSourceSingle: 'sensortower',
  });

  return (
    <div className="dbi-insights-page dbi-insights-page-filter-t">
      <div className="dbi-insights-page-filter">
        {!isMarketTypeSegmentHide && (
          <Segment
            className="segment-light"
            value={segment}
            // value={segment.toString()}
            onChange={(value: string) => {
              setSegment(value);
              dateDispatch({ type: 'marketType', payload: value });
              handleDestroyed();
            }}
            options={[
              { text: formatMessage({ id: 'dbi_market_mobile' }), value: 'mobile' },
              {
                text: formatMessage({ id: 'dbi_market_pc' }),
                value: 'pc',
                className: pcGameSegmentClassName,
              },
              { text: formatMessage({ id: 'dbi_market_console' }), value: 'console' },
            ]}
          />
        )}
      </div>
      {destroyed ? null : (
        <InsightsComp
          {...props}
          segment={segment}
          destroyed={destroyed}
          filter={date}
          filterDispatch={dateDispatch}
          isMarketSegmentHide={isMarketTypeSegmentHide}
        />
      )}
    </div>
  );
}
